import CHighcharts from "layouts/mainsection/components/CHighcharts";
import CMapHighcharts from "layouts/mainsection/components/CMapHighcharts";
import { checkObjects } from "helpers/Utils";
import { SpinLoader } from "./Loader";

export const createHChart =  (id = '', options = {}, callback = e => {}, loader = null) => {
  // console.log('checkObjects', checkObjects(options, 'xAxis.title'))
    
    return  <CHighcharts id={ id } options={
      {
        ...options,
        chart: {
          ...checkObjects(options, 'chart'),
          style: {
            fontFamily: "\"Poppins\", \"Lato\", \"sans-serif\"",
            fontSize: '0.9em',
            ...checkObjects(options, 'chart.style')
          },
        },
        colors: ['#09ad23', '#f39511', '#c3081d', '#f5dd35', '#ce16ea',
              '#ae191b', '#990099', '#e40000', '#7c0000', '#a8368d'],
        exporting: {enabled: false},
        credits: {
          enabled: false
        },
        title: {
          style: { "color": "#000", "fontSize": "1.1em", fontWeight: 'bold' },
          ...options.title,
        },
        xAxis: {
          ...checkObjects(options, 'xAxis'),
          title: {
            ...checkObjects(options, 'xAxis.title'),
            style: {
              color: 'black',
              fontWeight: 'bold',
              ...checkObjects(options, 'xAxis.title.style')
            },
            
          },
          labels: {  
            style: {
              color: 'black',
              fontWeight: 'bold'
            }
          },
          
        },
        yAxis: {
          ...checkObjects(options, 'yAxis'),
          title: {
            ...checkObjects(options, 'yAxis.title'),
            style: {
              color: 'black',
              fontWeight: 'bold',
              ...checkObjects(options, 'yAxis.title.style')
            },
            
          },
          labels: {  
            style: {
              color: 'black',
              fontWeight: 'bold'
            }
          },
          
        },
        
      }
    } 
    callbackchart={callback}
    loader= { loader ? loader :  '' }
    />
  




}

export const createHChartMaps = (id = '', options = {}, callback = e => {}, loader = null) => {
     
        
  return  <CMapHighcharts id={ id } 
  options={
    {
      ...options,
      chart: {
        ...checkObjects(options, 'chart'),
        style: {
          fontFamily: "\"Poppins\", \"Lato\", \"sans-serif\"",
          fontSize: '0.9em',
          ...checkObjects(options, 'chart.style')
        },
      },
      colors: ['#09ad23', '#f39511', '#c3081d', '#f5dd35', '#ce16ea',
              '#ae191b', '#990099', '#e40000', '#7c0000', '#a8368d'],
      exporting: {enabled: false},
      credits: {
        enabled: false
      },
      title: {
        ...options.title,
        style: { 
          "color": "#000", "fontSize": "1.1em", fontWeight: 'bold',
          ...checkObjects(options, 'title.style')
        },
      },
      xAxis: {
        ...checkObjects(options, 'xAxis'),
        title: {
          ...checkObjects(options, 'xAxis.title'),
          style: {
            color: 'black',
            fontWeight: 'bold',
            ...checkObjects(options, 'xAxis.title.style')
          },
          
        },
        labels: {  
          style: {
            color: 'black',
            fontWeight: 'bold'
          }
        },
        
      },
      yAxis: {
        ...checkObjects(options, 'yAxis'),
        title: {
          ...checkObjects(options, 'yAxis.title'),
          style: {
            color: 'black',
            fontWeight: 'bold',
            ...checkObjects(options, 'yAxis.title.style')
          },
          
        },
        labels: {  
          style: {
            color: 'black',
            fontWeight: 'bold'
          }
        },
        
      },
    }
  } 
  
  callbackchart={callback}
  loader={ loader ? loader : '' }
  />





}